import { selectUserState } from "redux/user/selectors/selectUserState";
import { createSelector } from "reselect";

export const selectCheckedIsLoggedIn = createSelector([selectUserState], (user) => user.checkedIsLoggedIn);
